import { render, staticRenderFns } from "./CustomIcon.vue?vue&type=template&id=71f2eeec&scoped=true"
import script from "./CustomIcon.vue?vue&type=script&lang=js"
export * from "./CustomIcon.vue?vue&type=script&lang=js"
import style0 from "./CustomIcon.vue?vue&type=style&index=0&id=71f2eeec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f2eeec",
  null
  
)

export default component.exports